import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Spinner from '../../shared/spinner.component';
import DropdownMenu from '../../shared/dropdownMenu';
import { waitForSpinnerToShowUp } from '../../shared/cursorHelpers';

class HamburgerMenu extends PureComponent {
  static propTypes = {
    exportToExcel: PropTypes.func.isRequired,
    disableExportToExcel: PropTypes.bool.isRequired,
  };

  state = {
    isGeneratingXlsxFile: false,
  };

  hideDropDown = () => {
    this.dropdown.hideDropDown();
  };

  exportToExcel = () => {
    this.setState({ isGeneratingXlsxFile: true }, () => {
      waitForSpinnerToShowUp({
        action: this.props.exportToExcel,
        callback: () => this.setState({ isGeneratingXlsxFile: false }),
      });
    });
  };

  render() {
    const { disableExportToExcel } = this.props;
    const { isGeneratingXlsxFile } = this.state;

    return (
      <DropdownMenu ref={dropdown => this.dropdown = dropdown} contentClassName="hamburger-menu">
        <button
          onClick={this.exportToExcel}
          disabled={disableExportToExcel || isGeneratingXlsxFile}
          className="hamburger-action link-button"
          tabIndex="0"
        >
          {isGeneratingXlsxFile
            ? (
              <span>
                <Spinner small/> Exporting
              </span>
            )
            : 'Export to Excel'
          }
        </button>
      </DropdownMenu>
    );
  }
}

export default HamburgerMenu;
